// extracted by mini-css-extract-plugin
export var descriptionContainer = "booking-section-module--description-container---PR5i";
export var photoColumn = "booking-section-module--photo-column--wpoVA";
export var photoWrapper = "booking-section-module--photo-wrapper--q8lc4";